import { render, staticRenderFns } from "./rating-scale.vue?vue&type=template&id=5015dd6e&scoped=true&"
import script from "./rating-scale.vue?vue&type=script&lang=js&"
export * from "./rating-scale.vue?vue&type=script&lang=js&"
import style0 from "./rating-scale.vue?vue&type=style&index=0&id=5015dd6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5015dd6e",
  null
  
)

export default component.exports